import React from "react";
import "./HomePage.css";

const CookiePolicy = () => (
  <div className="cookie-policy">
    <h4>Cookie Policy</h4>
    <p>
      This Cookie Policy explains how Give Stream uses cookies and similar
      technologies to recognize you when you visit our platform. It explains
      what these technologies are and why we use them, as well as your rights to
      control their use.
    </p>

    <h2>1. What Are Cookies?</h2>
    <p>
      Cookies are small data files that are placed on your computer or mobile
      device when you visit a website. They are widely used by website owners to
      make their websites work, or to work more efficiently, as well as to
      provide reporting information.
    </p>

    <h2>2. Why Do We Use Cookies?</h2>
    <p>We use cookies to:</p>
    <ul>
      <li>Recognize you when you visit our platform</li>
      <li>Remember your preferences and settings</li>
      <li>Improve our platform and services</li>
      <li>Analyze how our platform is performing</li>
      <li>Deliver targeted advertising</li>
    </ul>

    <h2>3. Types of Cookies We Use</h2>
    <p>We use the following types of cookies:</p>
    <ul>
      <li>Strictly necessary cookies</li>
      <li>Performance cookies</li>
      <li>Functional cookies</li>
      <li>Targeting cookies</li>
    </ul>

    <h2>4. Your Choices</h2>
    <p>
      You have the right to decide whether to accept or reject cookies. You can
      exercise your cookie preferences by adjusting your browser settings.
    </p>

    <h2>5. Changes to This Cookie Policy</h2>
    <p>
      We may update this Cookie Policy from time to time. We will notify you of
      any changes by posting the new policy on our platform.
    </p>

    <h2>6. Contact Us</h2>
    <p>
      If you have any questions about our use of cookies, please contact us at
      [info@givestream.com].
    </p>
  </div>
);

export default CookiePolicy;
